// import { openInNewTab } from 'modules/utils/router'
import { FC, useEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import { CloseCircle } from 'svgIcons'

interface OpenGraphPreviewProps {
  imageSrc?: string
  description?: string
  domain: string
  url: string
  onClose?: () => void
  className?: string
}

const OpenGraphPreview: FC<OpenGraphPreviewProps> = ({
  imageSrc,
  description,
  domain,
  url,
  onClose,
  className,
}) => {
  const imageRef = useRef<HTMLImageElement>(null)
  const [fullSizeImage, setFullSizeImage] = useState<boolean>(false)

  const handleClick = () => {
    if (window) {
      window.open(url, '_blank', 'noopener noreferrer')?.focus()
    }
  }

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.addEventListener('load', () => {
        const isFullSizeImage = (imageRef.current?.naturalWidth || 0) > 600
        setFullSizeImage(isFullSizeImage)
      })
    }
  }, [imageSrc, imageRef])

  return (
    <StyledWrapper fullSizeImage={fullSizeImage} className={className}>
      <div className="content-root" onClick={handleClick}>
        {imageSrc && (
          <img ref={imageRef} src={imageSrc} className="image" alt="og image" />
        )}
        <div className="description-root">
          <div className="description">{description}</div>
          <div className="domain">{domain}</div>
        </div>
      </div>
      {onClose && <CloseCircle className="og-close-button" onClick={onClose} />}
    </StyledWrapper>
  )
}

export default OpenGraphPreview

interface StyledWrapperProps {
  fullSizeImage: boolean
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  ${(props) => css`
    position: relative;
    background-color: #f5fafd;

    .content-root {
      display: flex;
      flex-direction: ${props.fullSizeImage ? 'column' : 'row'};
      ${!props.fullSizeImage &&
      `
      padding: 20px;
    `}
      :hover {
        cursor: pointer;
      }
    }

    .image {
      ${!props.fullSizeImage &&
      `
      margin-right: 14px;
      width: 134px;
      height: auto;
    `}
    }

    .description-root {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      ${props.fullSizeImage &&
      `
      padding: 20px;
    `}
    }

    .og-close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 28px;
      height: 28px;
      opacity: 0.75;

      g {
        fill: #333;
        stroke: #333;
      }

      path {
        fill: white;
      }

      :hover {
        cursor: pointer;
        opacity: 0.25;
      }
    }

    .description {
      display: -webkit-box;
      font-size: 15px;
      line-height: 24px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding-right: 30px;
    }

    .domain {
      font-size: 12px;
      color: #999;
    }
  `}
`
